module.exports = __webpack_public_path__ + "static/media/healthEnergyDrinks.9f6436a3.webp";